<template>
  <div>

    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Development</el-breadcrumb-item>
          <el-breadcrumb-item>Project</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
        Updating Time: {{ this.updateTime }}
        </el-col> -->
    </el-row>
    <!--卡片视图区域-->

    <el-card>
      <el-form :model="formInline" class="demo-form-inline">
        <el-row>
          <el-col :span = "6">
            <el-form-item label="Brand:" label-width="115px">
              <el-select v-model="formInline.brands" multiple collapse-tags
                         style="margin-left: 0px;" filterable
                         placeholder="please choose">
                <el-option
                  v-for="item in this.brandList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span = "6">
            <el-form-item label="Sequence No:" label-width="115px">
              <el-input v-model="formInline.sequenceNo" placeholder="Sequence No" clearable @blur="checkSequenceNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span = "12">
            <el-form-item label="ETD:" label-width="135px">
              <el-date-picker
                v-model="formInline.endofdev"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col  :span = "6">
            <el-form-item label="Acct Manager:" label-width="115px">
              <el-select v-model="formInline.salesRep"  v-if="this.userName.toUpperCase()==='J3P'" filterable collapse-tags clearable
                         style="margin-left: 0px;"
                         placeholder="please choose">
                <el-option
                  v-for="item in this.salesRepList"
                  :key="item.salesRep"
                  :label="item.salesRep"
                  :value="item.salesRep">
                  <span style="float: left">{{ item.salesRep }}</span>
                  <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
                </el-option>
              </el-select>
              <el-input v-model="formInline.salesRep"  v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='IPIT' || this.userName.toUpperCase()==='HBG'" placeholder="Account Manager" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span = "6">
            <el-form-item label="Description:" label-width="115px">
              <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span = "12">
            <el-form-item label="Project Leader:" label-width="135px" v-if="this.userName.toUpperCase()==='J3P'">
              <el-select v-model="formInline.projectLeader" collapse-tags filterable clearable
                         style="margin-left: 0px;"
                         placeholder="please choose">
                <el-option
                  v-for="item in this.createdList"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId">
                  <span style="float: left">{{ item.userId }}</span>
                  <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item   label="Status:" label-width="135px"  v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='IPIT' || this.userName.toUpperCase()==='HBG'">
            <!-- <el-form-item  label-width="39px" v-if="this.userName.toUpperCase()==='J3P'"> -->
              <el-select v-model="formInline.oppclo" collapse-tags
              placeholder="please choose">
                  <el-option
                  v-for="item in this.oppcloArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            <!-- <el-form-item  label-width="39px" v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='IPIT' || this.userName.toUpperCase()==='HBG'">
              <el-switch
                style="display: block"
                v-model="formInline.oppclo"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Active"
                inactive-text="Inactive">
              </el-switch> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col  :span = "6" >
            <el-form-item   label="Status:" label-width="115px"  v-if="this.userName.toUpperCase()==='J3P'">
            <!-- <el-form-item  label-width="39px" v-if="this.userName.toUpperCase()==='J3P'"> -->
              <el-select v-model="formInline.oppclo" collapse-tags
              placeholder="please choose">
                  <el-option
                  v-for="item in this.oppcloArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-switch
                style="display: block"
                v-model="formInline.oppclo"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Active"
                inactive-text="Inactive">
              </el-switch> -->
            </el-form-item>
          </el-col>
          <el-col :span = "15" style="margin-left: 111px;">
            <el-form-item >
              <el-button type="primary" style="margin-left: 312px;" v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='IPIT' || this.userName.toUpperCase()==='HBG'" @click="onSubmit">Search</el-button>
              <el-button type="primary" v-if="this.userName.toUpperCase()==='J3P'" @click="onSubmit">Search</el-button>
              <el-button type="primary" v-if="this.userName.toUpperCase()==='J3P'" @click="projectDialogOpen">Add</el-button>
              <el-button type="primary" v-if="this.userName.toUpperCase()==='J3P'" @click="exportToExcel">Excel</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-dialog title="PROJECT" class="dialogTitle"
                 width="70%" :visible.sync="dialogFormVisible">
        <el-form :model="projectOpenform" width="100%" label-width="250px" :rules="editFormRules" ref="projectOpenform" size="mini" font-size="7px">
          <div class="div-class1">
            <el-row>
              <el-col :span="7">
                <el-form-item label="Sales Site:" label-width="200px">
                  <el-select v-model="projectOpenform.crProject.salesSite" collapse-tags filterable
                             size="mini" style="margin-left: 0px;" v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose" @change="siteChange">
                    <el-option
                      v-for="item in this.sites"
                      :key="item.code"
                      :label="item.code"
                      :value="item.code">
                      <span style="float: left">{{ item.code }}</span>
                    </el-option>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.salesSite" disabled clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="projectOpenform.salesSiteDescr"
                          disabled>
                </el-input>
              </el-col>
              <el-col :span="10">
                <el-form-item label="Sequence No:" label-width="115px" style="margin-left: 90px;">
                  <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.sequenceNo" placeholder="Sequence No" maxlength="20" disabled></el-input>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.sequenceNo" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="Description:" label-width="200px">
                  <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.description" placeholder="Description" clearable></el-input>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.description" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="Planning:" label-width="200px">
                  <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.planning" placeholder="Planning" clearable></el-input>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.planning" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Customer/Prospect:" label-width="200px">
                  <el-select v-model="projectOpenform.crProject.bp"  collapse-tags clearable filterable remote reserve-keyword
                             style="margin-left:-120px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="bpChange"  :remote-method="remoteMethodCustomer" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">BP</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Company Name</span>
                      <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">Short Description</span>
                      <span style="margin-left: 70px; font-size: 10px;display:inline-block; width: 120px;">Customer Type</span>
                      <el-option
                        v-for="item in this.bpList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.name }}</span>
                        <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.shortDesc }}</span>
                        <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.type }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.bp" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="projectOpenform.bpCompanyName"
                          disabled>
                </el-input>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Type:" label-width="75px">
                  <el-select v-model="projectOpenform.crProject.type"  collapse-tags
                             style="margin-left: 0px;" v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose">
                    <el-option
                      v-for="item in this.projectType"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.type" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Brand:" label-width="200px">
                  <el-select v-model="projectOpenform.crProject.brand"  collapse-tags  clearable filterable remote reserve-keyword
                             style="margin-left:-120px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"  @change="brandChange" :remote-method="remoteMethodBrand" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 25px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Name</span>
                      <el-option
                        v-for="item in this.dimensionList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 25px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.name }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.brand" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="projectOpenform.brandDescr"
                          disabled>
                </el-input>
              </el-col>
              <el-col :span="5">
                <el-checkbox v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.hidden">Hidden</el-checkbox>
                <!-- <el-checkbox v-if="this.operation==='add'" v-model="projectOpenform.crProject.isHidden">Hidden</el-checkbox> -->
                <el-checkbox v-if="this.operation==='view'" v-model="projectOpenform.crProject.hidden" disabled>Hidden</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Packaging Manager:" label-width="200px">
                  <el-select v-model="projectOpenform.crProject.contact"  collapse-tags  clearable filterable allow-create remote reserve-keyword
                             style="margin-left:-120px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"  @change="contactChange"  :remote-method="remoteMethodContact" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Name</span>
                      <!-- <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">First Name</span> -->
                      <el-option
                        v-for="item in this.contactCRMList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.name }}</span>
                        <!-- <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.firstName }}</span> -->
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.contact" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="projectOpenform.contactName"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Project Manager:" label-width="200px">
                  <el-select v-model="projectOpenform.crProject.projectManager"  collapse-tags  clearable filterable allow-create remote reserve-keyword
                             style="margin-left:-120px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"  @change="pjChange"  :remote-method="remoteMethodContact" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Name</span>
                      <!-- <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">First Name</span> -->
                      <el-option
                        v-for="item in this.contactCRMList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.name }}</span>
                        <!-- <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.firstName }}</span> -->
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.projectManager" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="projectOpenform.pjName"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="15">
                <el-form-item label="QA Folder:" label-width="200px" style="text-align: left" >
                  <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.qaFolder" placeholder="QA Folder" clearable></el-input>
<!--                  <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.qaFolder" disabled></el-input>-->
                  <a v-if="this.operation==='view'" :href='projectOpenform.crProject.qaFolder' target="_blank">{{projectOpenform.crProject.qaFolder}}</a>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="div-class2" line-height="50%">
            <template>
              <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="Project" stretch="true" name="project">
                  <div class="div-title-class">Qualification</div>
                  <div class="div-project-class">
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="Account Manager:" label-width="150px">
                          <el-select v-model="projectOpenform.crProject.salesRep" collapse-tags clearable filterable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="salesRepChange">
                            <el-option
                              v-for="item in this.salesRepList"
                              :key="item.salesRep"
                              :label="item.salesRep"
                              :value="item.salesRep">
                              <span style="float: left">{{ item.salesRep }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.salesRep" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="projectOpenform.salesRepLastName"
                                  disabled>
                        </el-input>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="Category:" label-width="115px">
                          <el-select v-model="projectOpenform.crProject.category" collapse-tags clearable filterable
                                     style="margin-left: 0px;"    v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="categoryChange">
                            <el-option
                              v-for="item in this.categoryList"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                              <span style="float: left">{{ item.code }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.category" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="projectOpenform.categoryDescr"
                                  disabled>
                        </el-input>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="Opening date:" label-width="150px">
                          <el-date-picker v-if="this.operation==='edit' || this.operation==='add'"
                                          v-model="projectOpenform.crProject.openingDate"
                                          type="date"   value-format="yyyy-MM-dd"   style="width:100%"
                                          placeholder="Pick a day">
                          </el-date-picker>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.openingDate" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="ETD:" label-width="100px">
                          <el-date-picker v-if="this.operation==='edit' || this.operation==='add'"
                                          v-model="projectOpenform.crProject.endofdev"  size="mini"
                                          type="date"   value-format="yyyy-MM-dd" style="width:100%"
                                          placeholder="Pick a day">
                          </el-date-picker>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.endofdev" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="Launch:" label-width="100px">
                          <el-date-picker v-if="this.operation==='edit' || this.operation==='add'"
                                          v-model="projectOpenform.crProject.launch"
                                          type="date"   value-format="yyyy-MM-dd"   style="width:100%"
                                          placeholder="Pick a day">
                          </el-date-picker>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.launch" disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                    </el-row>
                  </div>
                  <div class="div-titlefin-class">Financial elements</div>
                  <div class="div-project-class">
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="Estimated QTY:" prop="estimatedQty" label-width="150px">
                          <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.estimatedQty" placeholder="Estimated QTY" clearable></el-input>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.estimatedQty" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Priority:" prop="priority" label-width="150px">
                          <el-select v-if="this.operation==='edit' || this.operation==='add'" v-model="projectOpenform.crProject.priority" placeholder="Please choose">
                            <el-option
                              v-for="item in this.priorityValues"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="projectOpenform.crProject.priority" disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="div-titlefin-class">Source</div>
                  <div class="div-project-class">
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="Project Leader:" label-width="150px" prop="crProject.projectLeader">
                          <el-select v-model="projectOpenform.crProject.projectLeader" collapse-tags filterable clearable
                                     size="mini" style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-model="projectOpenform.crProject.projectLeader" v-if="this.operation==='view'" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="created by:" label-width="150px" prop="crProject.createBy">
                          <el-select v-model="projectOpenform.crProject.createBy" collapse-tags filterable
                                     size="mini" style="display: flex;" v-if="this.operation==='add'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-model="projectOpenform.crProject.createBy" v-if="this.operation==='view' || this.operation==='edit'" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" v-if="this.operation==='edit' || (this.operation==='view' && (projectOpenform.crProject.updateBy !== null || projectOpenform.crProject.updateBy !== ''))">
                        <el-form-item label="updated by:" label-width="180px" prop="crProject.updateBy">
                          <el-select v-model="projectOpenform.crProject.updateBy" filterable collapse-tags   clearable
                                     style="margin-left: 0px;"    v-if="this.operation==='edit'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view' && (projectOpenform.crProject.updateBy !== null || projectOpenform.crProject.updateBy !== '')" v-model="projectOpenform.crProject.updateBy" disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="Steps" name="second">
                  <div class="div-class">
                    <!-- <template v-if="this.operation!=='' && this.operation!==null"> -->
                    <el-table :data="projectOpenform.stepList" border stripe style="width: 100%" size="mini">
                      <!-- <template  v-if="this.operation!==null && (this.operation==='edit' || this.operation==='add')"> -->
                      <el-table-column property="date" label="Date">
                        <template slot-scope="scope">
                          <el-date-picker  v-if="operation!=='' && (operation==='edit' || operation==='add')"
                                           v-model="scope.row.date"
                                           type="date"  value-format="yyyy-MM-dd"
                                           placeholder="Pick a day" size="mini">
                          </el-date-picker>
                          <el-input v-if="operation==='view'" v-model="scope.row.date" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="step" label="Step">
                        <template slot-scope="scope">
                          <el-select   v-if="operation!=='' && (operation==='edit' || operation==='add')" v-model="scope.row.step" collapse-tags clearable filterable
                                       style="margin-left: 0px;" size="mini"
                                       placeholder="please choose"   @change="stepCodeChange(scope.row, scope.$index)">
                            <el-option
                              v-for="item in stepCodeList"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                              <span style="float: left">{{ item.code }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="operation==='view'" v-model="scope.row.step" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="description" label="Description">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.description" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="phaseEnd" label="Phase End">
                        <template slot-scope="scope">
                          <el-checkbox v-model="scope.row.phaseEnd" size="mini" v-if="operation==='edit' || operation==='add'"></el-checkbox>
                          <el-checkbox v-model="scope.row.phaseEnd" size="mini" v-if="operation==='view'" disabled></el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column property="reason" label="Reason">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.reason" v-if="operation==='edit' || operation==='add'" size="mini"></el-input>
                          <el-input v-model="scope.row.reason" v-if="operation==='view'" disabled size="mini"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="operation" v-if="operation!=='' && (operation==='edit' || operation==='add')">
                        <template slot-scope="props">
                          <el-button type="info" plain size="mini" @click="addStepRow(props.row.id)">Add</el-button>
                          <el-button type="info" plain size="mini" @click="delStepRow(props.row.id)">Delete</el-button>
                        </template>
                      </el-table-column>
                      <!-- </template> -->
                      <!-- <template  v-if="this.operation!==null && this.operation==='view'">
                      <el-table-column property="date" label="Date">
                            <template slot-scope="scope">
                              {{ scope.row.date }}
                            </template>
                      </el-table-column>

                      <el-table-column property="step" label="Step">
                          <template slot-scope="scope">
                            {{ scope.row.step }}
                          </template>
                      </el-table-column>

                      <el-table-column property="description" label="Description">
                          <template slot-scope="scope">
                            {{ scope.row.description }}
                          </template>
                      </el-table-column>

                      <el-table-column property="phaseEnd" label="Phase end">
                          <template slot-scope="scope">
                            {{ scope.row.phaseEnd }}
                          </template>
                      </el-table-column>

                      <el-table-column property="reason" label="Reason">
                          <template slot-scope="scope">
                            {{ scope.row.reason }}
                          </template>
                      </el-table-column>
                      </template> -->
                    </el-table>
                    <!-- </template> -->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Associated Projects" name="third">
                  <div class="div-class">
                    <!-- <template v-if="operation!=='' && this.operation!==null"> -->
                    <el-table :data="projectOpenform.associatedPrjList" border stripe style="width: 100%" size="mini">
                      <!-- <template v-if="operation!==null && (operation==='edit' || operation==='add')"> -->
                      <el-table-column property="code" label="Code">
                        <template slot-scope="scope">
                          <el-select v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.code" collapse-tags
                                     style="margin-left: 0px;"  size="mini" filterable  remote reserve-keyword
                                     placeholder="please choose"  @change="associatedPrjChange(scope.row, scope.$index)"  :remote-method="remoteMethodAssoPrj" :loading="loading">
                            <el-option
                              v-for="item in linkedAssociatedPrjList"
                              :key="item.sequenceNo"
                              :label="item.sequenceNo"
                              :value="item.sequenceNo">
                              <span style="float: left">{{ item.sequenceNo }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="operation==='view'" v-model="scope.row.code" disabled size="mini"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="description" label="Project Description">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.description" disabled size="mini"></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column label="operation" v-if="operation!==null && (operation==='edit' || operation==='add')">
                        <template slot-scope="props">
                          <el-button type="info" plain size="mini" @click="addAssoicatePrjRow(props.row.id)">Add</el-button>
                          <el-button type="info" plain size="mini" @click="delAssociationPrjRow(props.row.id)">Delete</el-button>
                        </template>
                      </el-table-column>
                      <!-- </template> -->
                      <!-- <template  v-if="this.operation!==null && this.operation==='view'">
                       <el-table-column property="code" label="Code">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.code" disabled size="mini"></el-input>
                              </template>
                        </el-table-column>

                        <el-table-column property="description" label="Project Description">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.description" disabled size="mini"></el-input>
                            </template>
                        </el-table-column>
                               </template> -->
                    </el-table>
                    <!-- </template> -->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Competitors" name="competitors">
                  <div class="div-class">
                    <!-- <template v-if="this.operation!=='' && this.operation!==null"> -->
                    <el-table :data="projectOpenform.competitorList" border stripe style="width: 100%" size="mini">
                      <el-table-column property="competitor" label="Competitor">
                        <template slot-scope="scope">
                          <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.competitor" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.competitor" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="description" label="Description">
                        <template slot-scope="scope">
                          <el-input  v-if="operation!==null && (operation==='edit' || operation==='add')"  v-model="scope.row.description" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.description" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column v-if="operation!==null && (operation==='edit' || operation==='add')"  property="competitorAmt" label="Competitor Amount">
                        <template slot-scope="scope">
                          <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.competitorAmt" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.competitorAmt" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="strength" label="Strengths">
                        <template slot-scope="scope">
                          <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.strength" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.strength" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="weakness" label="Weaknesses">
                        <template slot-scope="scope">
                          <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.weakness" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.weakness" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="operation" v-if="operation!==null && (operation==='edit' || operation==='add')">
                        <template slot-scope="props">
                          <el-button type="info" plain size="mini" @click="addCompetitorRow(props.row.id)">Add</el-button>
                          <el-button type="info" plain size="mini" @click="delCompetitorRow(props.row.id)">Delete</el-button>
                        </template>
                      </el-table-column>
                      <!-- <template  v-if="this.operation!==null && this.operation==='view'">
                        <el-table-column property="competitor" label="Competitor">
                           <template slot-scope="scope">
                             {{ scope.row.competitor }}
                               </template>
                         </el-table-column>
                         <el-table-column property="description" label="Description">
                            <template slot-scope="scope">
                              {{ scope.row.description }}
                                </template>
                          </el-table-column>
                         <el-table-column property="competitorAmt" label="Competitor Amount">
                            <template slot-scope="scope">
                              {{ scope.row.competitorAmt }}
                                </template>
                          </el-table-column>
                          <el-table-column property="strength" label="Strengths">
                             <template slot-scope="scope">
                               {{ scope.row.strength }}
                                 </template>
                           </el-table-column>
                           <el-table-column property="weakness" label="Weaknesses">
                              <template slot-scope="scope">
                                {{ scope.row.competitor }}
                                  </template>
                            </el-table-column>https://www.myirequest.com
                        </template> -->
                    </el-table>
                    <!-- </template> -->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Existing Components" name="competitors1">
                  <div class="div-class">
                    <el-table :data="projectOpenform.componentList" border stripe style="width: 100%" size="mini">
                      <el-table-column property="component" label="Component">
                        <template slot-scope="scope">
                          <el-select v-model="scope.row.component" placeholder="please choose" size="mini"  collapse-tags clearable filterable
                                       style="margin-left: 0px;"  v-if="operation==='edit' || operation==='add'">
                              <el-option
                                v-for="item in taskCategoryList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left">{{ item.code }}</span>
                                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                              </el-option>
                            </el-select>
                          <!-- <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.component" placeholder="Please input" size="mini"></el-input> -->
                          <el-input v-model="scope.row.component" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="bp" label="Business Partner">
                        <template slot-scope="scope">
                          <el-select v-model="scope.row.bp" placeholder="please choose" size="mini" collapse-tags clearable filterable
                                       style="margin-left: 0px;"  v-if="operation==='edit' || operation==='add'">
                              <el-option
                                v-for="item in salesRepList"
                                :key="item.salesRep"
                                :label="item.salesRep"
                                :value="item.salesRep">
                                <span style="float: left">{{ item.salesRep }}</span>
                                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
                              </el-option>
                            </el-select>
                          <!-- <el-input  v-if="operation!==null && (operation==='edit' || operation==='add')"  v-model="scope.row.bp" placeholder="Please input" size="mini"></el-input> -->
                          <el-input v-model="scope.row.bp" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column property="comment" label="Comment">
                        <template slot-scope="scope">
                          <el-input v-if="operation!==null && (operation==='edit' || operation==='add')" v-model="scope.row.comment" placeholder="Please input" size="mini"></el-input>
                          <el-input v-model="scope.row.comment" v-if="operation==='view'" size="mini" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="operation" v-if="operation!==null && (operation==='edit' || operation==='add')">
                        <template slot-scope="props">
                          <el-button type="info" plain size="mini" @click="addComponentRow(props.row.id)">Add</el-button>
                          <el-button type="info" plain size="mini" @click="delComponentRow(props.row.id)">Delete</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Reference" name="reference">
                  <div class="div-title-class">Picture</div>
                  <div class="div-class">
                    <el-upload
                      class="upload-demo"
                      v-model="projectOpenform.picReference"
                      action="https://www.myirequest.com:8081/customer/fileUpload"
                      multiple
                      show-file-list
                      :before-upload="beforeUpload"
                      :on-preview="handlePreview"
                      :on-success="handleSuccessPic"
                      :file-list="picList"
                      :on-remove="handleRemovePic"
                      list-type="picture">
                      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
                      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">png/gif/jpg/jpeg files with a size less than 10mb</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                  </div>
                  <div class="div-titlefin-class">Document</div>
                  <div class="div-class">
                    <el-upload
                      class="upload-demo"
                      v-model="projectOpenform.docReference"
                      action="https://www.myirequest.com:8081/customer/fileUpload"
                      multiple
                      show-file-list
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .csv"
                      :on-preview="handlePreviewDoc"
                      :on-success="handleSuccessDoc"
                      :on-remove="handleRemoveDoc"
                      :file-list="docList"
                      list-type="text">
                      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
                      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">docx/xlsx/xls/ppt/pptx/csv/pdf files with a size less than 500kb</div>
                    </el-upload>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </template>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="this.operation==='edit' || this.operation === 'add'" @click="dialogFormVisible = false">Cancel</el-button>
          <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="projectDialogSave('projectOpenform')">Save</el-button>
          <!-- <el-button v-if="this.operation==='view'" type="primary" @click="exportToExcel('projectOpenform')">Excel</el-button> -->
        </div>
      </el-dialog>

      <!-- CRProject 列表区域 -->
      <el-table :data="crProjectList" border stripe style="width: 100%">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          prop="brand"
          label="Brand"         sortable
          width="120">
        </el-table-column>
        <el-table-column
          prop="sequenceNo"      sortable
          label="Sequence No"
          width="120">
        </el-table-column>
        <el-table-column
          prop="description"  :show-overflow-tooltip="true"
          label="Description"
          width="300">
        </el-table-column>
        <el-table-column
          prop="bp"
          label="Business Partner"        sortable
          width="160">
        </el-table-column>

        <el-table-column
          prop="salesRep"        sortable
          label="Account Manager"
          width="150">
        </el-table-column>

        <el-table-column
          label="Operation"
          width="350">
          <template slot-scope="props">
            <el-tooltip class="item" effect="dark" content="Task" placement="top">
              <el-button type="info" size="mini" icon="el-icon-setting" @click="jumpTaskState(props.row.sequenceNo)" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Schedule" placement="top">
              <el-button type="warning"  size="mini" icon="el-icon-star-off" @click="jumpScheduleState(props.row.sequenceNo)" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Timeline" placement="top">
              <el-button type="success" size="mini" icon="el-icon-help" @click="jumpTimelineState(props.row.sequenceNo)" circle></el-button>
            </el-tooltip>
            <!-- <el-button type="info" plain size="mini" @click="jumpTaskState(props.row.sequenceNo)">Task</el-button>
            <el-button type="info" plain size="mini" @click="view(props.row.sequenceNo)">Timeline</el-button>
            <el-button type="info" plain size="mini" @click="view(props.row.sequenceNo)">Schedule</el-button> -->
            <el-button type="info" plain size="mini" @click="view(props.row.id,props.row)">View</el-button>
            <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="edit(props.row.id,props.row)">Edit</el-button>
            <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="del(props.row.id)">Delete</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页区域-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="formInline.page"
        :page-sizes="[10, 20, 30, 50, 100, total]"
        :page-size="formInline.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        sequenceNo: '',
        oppclo: '1',
        projectLeader: '',
        endofdev: [],
        brands: [],
        salesRep: '',
        description: '',
        token: '',
        page: 1,
        rows: 100
      },
      oppcloArr: [{
        value: '1',
        label: 'Active'
      }, {
        value: '2',
        label: 'Inactive'
      }, {
        value: '3',
        label: 'All'
      }],
      endofdevStart: '',
      endofdevEnd: '',
      activeName: 'project',
      // assoPrjLoading: false,
      // customerLoading: false,
      // brandLoading: false,New Mold, Duplicate, Flanker, Standard, Replacement, QCAP
      // contactLoading: false,
      projectType: ['New Mold', 'Duplicate', 'Flanker', 'Standard', 'Replace', 'QCAP', 'Turnkey'],
      loading: false,
      picList: [],
      docList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      operation: '',
      sites: [{
        code: 'E10',
        description: 'Easyfrenchy'
      }, {
        code: 'J10',
        description: 'J3P'
      }, {
        code: 'S10',
        description: 'SOURCING PERFUME COSMETIC SH LTD'
      }, {
        code: 'A10',
        description: 'PPI'
      }, {
        code: 'H10',
        description: 'Saphi HK'
      }, {
        code: 'P10',
        description: 'Saphired'
      }],
      // activeName: 'second',
      projectOpenform: {
        crProject: {
          id: -1,
          salesSite: '',
          sequenceNo: '',
          description: '',
          planning: '',
          type: 'New Mold',
          bp: '',
          isProspect: false,
          hidden: false,
          brand: '',
          contact: '',
          projectManager: '',
          qaFolder: '',
          salesRep: '',
          category: '',
          openingDate: null,
          endofdev: null,
          launch: null,
          estimatedQty: '',
          priority: 1,
          createBy: ''
        },
        stepList: [],
        associatedPrjList: [],
        competitorList: [],
        componentList: [],
        salesSiteDescr: '',
        docReference: [],
        picReference: [],
        bpCompanyName: '',
        brandDescr: '',
        contactName: '',
        pjName: '',
        salesRepLastName: '',
        categoryDescr: ''
      },
      userName: '',
      loginName: '',
      crProjectList: [],
      // stepList: [],
      linkedAssociatedPrjList: [],
      linkedAssociatedPrjListbak: [],
      // competitorList: [],
      maxStepId: 0,
      maxAssociatePrjId: 0,
      maxCompetitorId: 0,
      maxComponentId: 0,
      brandList: [],
      bpList: [],
      bpListbak: [],
      dimensionList: [],
      brandListbak: [],
      contactCRMList: [],
      contactCRMListbak: [],
      salesRepList: [],
      categoryList: [],
      taskCategoryList: [],
      brandManagerList: [],
      stepCodeList: [],
      priorityValues: [1, 2, 3, 4, 5],
      total: 0,
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      fileParam: {
        files: '',
        fileName: '',
        sequenceNo: ''
      },
      dialogFormVisible: false,
      createdList: [],
      editFormRules: {
        crProject: {
          projectLeader: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          createBy: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          updateBy: [
            { required: true, trigger: 'blur', message: 'Required' }
          ]
        }
      }

    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.loginName = window.sessionStorage.getItem('loginname').toUpperCase()
    this.getCRProjects()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
    this.getSalesReps()
    this.getProjectLeaders()
    this.getLinkedAssociateCRProjectList()
    this.getAllCustomers()
    this.getBrandList()
    this.getContactCrmList()
    this.getCategoryList()
    this.getTaskCategories()
    this.getUserByList()
    this.getStepCodeList()
    this.getBrandManager()
  },
  methods: {
    jumpTaskState (value) {
      // window.sessionStorage.setItem('activePath', activePath)
      this.$router.push({ name: 'CRTaskLink', params: { selected: value } })
      // this.$router.push({ path: '/CRTask', query: { selected: value } })
      // console.log('activepath')
      // this.activePath = activePath
    },
    jumpScheduleState (value) {
      // window.sessionStorage.setItem('activePath', activePath)
      this.$router.push({ name: 'scheduleLink', params: { selected: value } })
      // this.$router.push({ path: '/CRTask', query: { selected: value } })
      // console.log('activepath')
      // this.activePath = activePath
    },
    jumpTimelineState (value) {
      // window.sessionStorage.setItem('activePath', activePath)
      this.$router.push({ name: 'timelineLink', params: { selected: value } })
      // this.$router.push({ path: '/CRTask', query: { selected: value } })
      // console.log('activepath')
      // this.activePath = activePath
    },
    remoteMethodBrand (query) {
      // this.dimensionList = this.brandListbak
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.dimensionList = this.brandListbak.filter(item => {
            var code = item.code
            if (item.code === null) {
              code = ''
            }
            var name = item.name
            if (name === null) {
              name = ''
            }
            return code.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.dimensionList = this.brandListbak
        // this.options = []
      }
    },
    remoteMethodContact (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.contactCRMList = this.contactCRMListbak.filter(item => {
            var code = item.code
            if (item.code === null) {
              code = ''
            }
            var name = item.name
            if (name === null) {
              name = ''
            }
            /* var firstName = item.firstName
            if (firstName === null) {
              firstName = ''
            }
            var lastName = item.lastName
            if (lastName === null) {
              lastName = ''
            } */
            return code.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.contactCRMList = this.contactCRMListbak
      }
    },
    remoteMethodCustomer (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.bpList = this.bpListbak.filter(item => {
            var code = item.code
            if (item.code === null) {
              code = ''
            }
            var name = item.name
            if (name === null) {
              name = ''
            }
            return code.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.bpList = this.bpListbak
      }
    },
    remoteMethodAssoPrj (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.linkedAssociatedPrjList = this.linkedAssociatedPrjListbak.filter(item => {
            return item.sequenceNo.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.description.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.linkedAssociatedPrjList = this.linkedAssociatedPrjListbak
      }
    },
    siteChange (value) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === value) {
          this.projectOpenform.salesSiteDescr = this.sites[i].description
          break
        }
      }
    },
    associateCRPrjChange (value) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === value) {
          this.projectOpenform.salesSiteDescr = this.sites[i].description
          break
        }
      }
    },
    bpChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.bpCompanyName = ''
      }
      for (var i = 0; i < this.bpList.length; i++) {
        if (this.bpList[i].code === value) {
          this.projectOpenform.bpCompanyName = this.bpList[i].name
          break
        }
      }
    },
    brandChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.brandDescr = ''
      }
      for (var i = 0; i < this.dimensionList.length; i++) {
        if (this.dimensionList[i].code === value) {
          this.projectOpenform.brandDescr = this.dimensionList[i].name
          break
        }
      }
      for (var j = 0; j < this.brandManagerList.length; j++) {
        if (this.brandManagerList[j].brand === value) {
          this.projectOpenform.crProject.salesSite = this.brandManagerList[j].site
          // console.log('this.brandManagerList[i].pkgManager === ' + this.brandManagerList[i].pkgManager)
          this.projectOpenform.crProject.contact = this.brandManagerList[j].pkgManager
          this.projectOpenform.crProject.projectManager = this.brandManagerList[j].prjManager
          this.projectOpenform.crProject.salesRep = this.brandManagerList[j].acctManager
          this.siteChange(this.projectOpenform.crProject.salesSite)
          this.contactChange(this.projectOpenform.crProject.contact)
          this.pjChange(this.projectOpenform.crProject.projectManager)
          this.salesRepChange(this.projectOpenform.crProject.salesRep)
          break
        }
      }
    },
    contactChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.contactName = ''
      }
      for (var i = 0; i < this.contactCRMList.length; i++) {
        if (this.contactCRMList[i].code === value) {
          this.projectOpenform.contactName = this.contactCRMList[i].name
          break
        }
      }
    },
    pjChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.pjName = ''
      }
      for (var i = 0; i < this.contactCRMList.length; i++) {
        if (this.contactCRMList[i].code === value) {
          this.projectOpenform.pjName = this.contactCRMList[i].name
          break
        }
      }
    },
    salesRepChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.salesRepLastName = ''
      }
      for (var i = 0; i < this.salesRepList.length; i++) {
        if (this.salesRepList[i].salesRep === value) {
          this.projectOpenform.salesRepLastName = this.salesRepList[i].lastName
          break
        }
      }
    },
    categoryChange (value) {
      if (value === '' || value === null) {
        this.projectOpenform.categoryDescr = ''
      }
      for (var i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].code === value) {
          this.projectOpenform.categoryDescr = this.categoryList[i].description
          break
        }
      }
    },
    stepCodeChange (row, index) {
      // if (row.code === '' || row.code === null) {
      //   row.description = ''
      // }
      for (var i = 0; i < this.stepCodeList.length; i++) {
        if (this.stepCodeList[i].code === row.step) {
          this.projectOpenform.stepList[index].description = this.stepCodeList[i].description
          break
        }
      }
    },
    associatedPrjChange (row, index) {
      for (var i = 0; i < this.linkedAssociatedPrjList.length; i++) {
        if (this.linkedAssociatedPrjList[i].sequenceNo === row.code) {
          this.projectOpenform.associatedPrjList[index].description = this.linkedAssociatedPrjList[i].description
          break
        }
      }
    },
    handleRemovePic (file, fileList) {
      // this.fileParam.files = file
      // this.fileParam.fileName = file.name
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // await this.$http.get('/customer/fileRemove', { params: this.fileParam })
      for (var i = 0; i < this.projectOpenform.picReference.length; i++) {
        if (file.name === this.projectOpenform.picReference[i].fileName) {
          this.projectOpenform.picReference.splice(i, 1)
        }
      }
    },
    handleRemoveDoc (file, fileList) {
      for (var i = 0; i < this.projectOpenform.docReference.length; i++) {
        if (file.name === this.projectOpenform.docReference[i].fileName) {
          this.projectOpenform.docReference.splice(i, 1)
        }
      }
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handlePreviewDoc (file) {
      // let params = {}
      // console.log('fileList doc === ' + fileList)
      const url = 'https://www.myirequest.com:8081/' + file.name
      // params = JSON.parse(url)
      const len = url.lastIndexOf('.')
      const type = url.substring(len + 1)
      if (
        type === 'doc' ||
        type === 'docx' ||
        type === 'xlsx' ||
        type === 'xls' ||
        type === 'ppt' ||
        type === 'pptx' ||
        // type === 'pdf' ||
        type === 'csv'
      ) {
        document.location.href = url
      } else {
        window.open(url, 'hello')
      }
      // } else {
      //   // 圖片會直接在瀏覽器中打開所以，打開新的頁面
      //   window.open(params.url, 'hello')
      // }
      // if (
      //   type === 'doc' ||
      //   type === 'docx' ||
      //   type === 'xlsx' ||
      //   type === 'xls' ||
      //   type === 'ppt' ||
      //   type === 'pptx' ||
      //   type === 'csv'
      // ) {
      //   console.log('params.url === ' + params.url)
      //   document.location.href = params.url
      // } else {
      //   // 圖片會直接在瀏覽器中打開所以，打開新的頁面
      //   window.open(params.url, 'hello')
      // }
    },
    async handleUploadFileList () {
      const formData = new FormData()
      this.picList.forEach((_) => {
        formData.append('file', _.raw)
      })
      // const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      await this.$http.post(`//172.0.0.1:8081/fileHandler?sequenceNo=${this.projectOpenform.crProject.sequenceNo}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then((r) => {
        console.log(r)
      }).catch((e) => {
        console.log(e)
      })
    },
    beforeUpload (file) {
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: 'Warning',
          message: 'Please upload image/png, image/gif, image/jpg, image/jpeg pictures.'
        })
        return false
      }
      const size = file.size / 1024 / 1024
      if (size > 10) {
        this.$notify.warning({
          title: 'Warning',
          message: 'Pictures with a size less than 10M.'
        })
        return false
      }
    },
    handleSuccessPic (response, file, fileList) {
      this.projectOpenform.picReference.push({ fileName: file.name, type: 'picture' })
      // console.log('fileList === ' + this.fileList)
      // console.log('res.status === ' + fileList)
      // this.fileParam.files = fileList.
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // const { data: res } = await this.$http.get('/customer/fileHandler', { params: this.fileParam })
      // this.brandList = await res.brands
      // if (response.status === 1) {
      //   console.log('fileList333333333333====== ' + fileList)
      // }
    },
    handleSuccessDoc (response, file, fileList) {
      this.projectOpenform.docReference.push({ fileName: file.name, type: 'document' })
      // this.projectOpenform.reference.push(file.name)
      // console.log('fileList === ' + this.fileList)
      // console.log('res.status === ' + fileList)
      // this.fileParam.files = fileList.
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // const { data: res } = await this.$http.get('/customer/fileHandler', { params: this.fileParam })
      // this.brandList = await res.brands
      // if (response.status === 1) {
      //   console.log('fileList333333333333====== ' + fileList)
      // }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getSalesReps () {
      const { data: res } = await this.$http.get('/customer/getSalesRepList')
      this.salesRepList = await res.salesRepList
    },
    async getProjectLeaders () {
      const { data: res } = await this.$http.get('/customer/getUserByList')
      this.createdList = await res.userByList
    },
    async getLinkedAssociateCRProjectList () {
      const { data: res } = await this.$http.get('/customer/getLinkedAssociateCRProjectList')
      this.linkedAssociatedPrjList = await res.rows
      this.linkedAssociatedPrjListbak = this.linkedAssociatedPrjList
    },
    async getAllCustomers () {
      const { data: res } = await this.$http.get('/customerBrand/allcustomerList')
      this.bpList = await res.rows
      this.bpListbak = this.bpList
    },
    async getBrandList () {
      const { data: res } = await this.$http.get('/customerBrand/getAllbrands')
      this.dimensionList = await res.rows
      this.brandListbak = this.dimensionList
    },
    async getContactCrmList () {
      const { data: res3 } = await this.$http.get('/customer/getContactCrmList')
      this.contactCRMList = await res3.contactCRMList
      this.contactCRMListbak = this.contactCRMList
    },
    async getCategoryList () {
      const { data: res5 } = await this.$http.get('/customer/getCategoryList')
      this.categoryList = await res5.categoryList
    },
    async getUserByList () {
      const { data: res6 } = await this.$http.get('/customer/getUserByList')
      this.createdList = await res6.userByList
    },
    async getStepCodeList () {
      const { data: res7 } = await this.$http.get('/customer/getStepCodeList')
      this.stepCodeList = await res7.stepCodeList
    },
    async getTaskCategories () {
      const { data: res9 } = await this.$http.get('/customer/getTaskCategoryList')
      this.taskCategoryList = await res9.taskCategoryList
      console.log('size === ' + this.categoryList.size)
    },
    async getBrandManager () {
      const { data: res10 } = await this.$http.get('/customer/getBrandManagerList')
      this.brandManagerList = await res10.brandManagerList
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getCRProjects()
    },
    async projectDialogOpen () {
      this.operation = 'add'
      this.projectOpenform.stepList = []
      this.projectOpenform.associatedPrjList = []
      this.projectOpenform.competitorList = []
      this.projectOpenform.componentList = []
      this.projectOpenform.picReference = []
      this.projectOpenform.docReference = []
      this.projectOpenform.salesSiteDescr = ''
      this.projectOpenform.bpCompanyName = ''
      this.projectOpenform.brandDescr = ''
      this.projectOpenform.contactName = ''
      this.projectOpenform.salesRepLastName = ''
      this.projectOpenform.categoryDescr = ''
      this.picList = []
      this.docList = []
      this.projectOpenform.crProject = { id: -1, salesSite: '', sequenceNo: '', hidden: false, description: '', planning: '', type: 'New Mold', bp: '', brand: '', contact: '', salesRep: '', category: '', openingDate: null, endofdev: null, launch: null, estimatedQty: '', priority: 1, createBy: this.loginName }
      const { data: res } = await this.$http.get('/customer/getSequenceNo')
      this.projectOpenform.crProject.sequenceNo = res.sequenceNo

      var stepObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, date: '', step: '', description: '', phaseEnd: false, reason: '' }
      this.projectOpenform.stepList.push(stepObj)
      // console.log('11111111111111')
      // const { data: res4 } = await this.$http.get('/customer/getLinkedAssociateCRProjectList')
      // this.linkedAssociatedPrjList = await res4.rows
      // console.log('linkedAssociatedPrjList===' + this.linkedAssociatedPrjList.length)

      var associatedPrjObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, code: '', description: '' }
      this.projectOpenform.associatedPrjList.push(associatedPrjObj)

      var competitorObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, competitor: '', description: '', competitorAmt: '', strength: '', weakness: '' }
      this.projectOpenform.competitorList.push(competitorObj)

      var componentObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, component: '', bp: '', comment: '' }
      this.projectOpenform.componentList.push(componentObj)
      console.log('wwwwwwwww')
      this.dialogFormVisible = true
    },
    async edit (value, var2) {
      // console.log(33333)
      // console.log(this.crProjectList)
      // console.log(55555)
      // console.log(var2)
      this.dialogFormVisible = true
      this.operation = 'edit'
      this.projectOpenform.stepList = []
      this.projectOpenform.associatedPrjList = []
      this.projectOpenform.competitorList = []
      this.projectOpenform.componentList = []
      this.projectOpenform.picReference = []
      this.projectOpenform.docReference = []
      this.projectOpenform.salesSiteDescr = ''
      this.projectOpenform.bpCompanyName = ''
      this.projectOpenform.brandDescr = ''
      this.projectOpenform.contactName = ''
      this.projectOpenform.pjName = ''
      this.projectOpenform.salesRepLastName = ''
      this.projectOpenform.categoryDescr = ''
      const { data: res } = await this.$http.get('/customer/getCRProject', { params: { value: value } })
      if (res.crProject.openingDate !== null) {
        res.crProject.openingDate = res.crProject.openingDate.substr(0, 10).replace('/', '-').replace('/', '-')
      }
      if (res.crProject.endofdev !== null) {
        res.crProject.endofdev = res.crProject.endofdev.substr(0, 10).replace('/', '-').replace('/', '-')
      }
      if (res.crProject.launch !== null) {
        res.crProject.launch = res.crProject.launch.substr(0, 10).replace('/', '-').replace('/', '-')
      }
      this.projectOpenform.crProject = res.crProject
      /* if (res.crProject.isHidden === undefined) {
        this.projectOpenform.crProject.isHidden = false
      } */
      // this.projectOpenform.crProject.openingDate = new Date(res.crProject.openingDate)
      this.projectOpenform.stepList = res.stepList
      this.projectOpenform.associatedPrjList = res.associateProjectList
      this.projectOpenform.competitorList = res.competitorList
      this.projectOpenform.componentList = res.componentList
      this.projectOpenform.picReference = []
      this.projectOpenform.docReference = []
      this.picList = []
      this.docList = []
      if (res.fPicfileList !== null && res.fPicfileList.length > 0) {
        for (var i = 0; i < res.fPicfileList.length; i++) {
          this.picList.push({ name: res.fPicfileList[i].fileName, url: 'https://www.myirequest.com:8081/' + res.fPicfileList[i].fileName })
          this.projectOpenform.picReference.push({ fileName: res.fPicfileList[i].fileName, type: 'picture' })
        }
      }
      if (res.fDocfileList !== null && res.fDocfileList.length > 0) {
        for (var j = 0; j < res.fDocfileList.length; j++) {
          this.docList.push({ name: res.fDocfileList[j].fileName, url: 'https://www.myirequest.com:8081/' + res.fDocfileList[j].fileName })
          this.projectOpenform.docReference.push({ fileName: res.fDocfileList[j].fileName, type: 'document' })
        }
      }
      if (res.stepList === null || res.stepList.length === 0) {
        var stepObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, date: '', step: '', description: '', phaseEnd: false, reason: '' }
        this.projectOpenform.stepList.push(stepObj)
      }
      if (res.associateProjectList === null || res.associateProjectList.length === 0) {
        var associatedPrjObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, code: '', description: '' }
        this.projectOpenform.associatedPrjList.push(associatedPrjObj)
      }

      if (res.competitorList === null || res.competitorList.length === 0) {
        var competitorObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, competitor: '', description: '', competitorAmt: '', strength: '', weakness: '' }
        this.projectOpenform.competitorList.push(competitorObj)
      }
      if (res.componentList === null || res.componentList.length === 0) {
        var componentObj = { id: 0, crProjectId: this.projectOpenform.crProject.sequenceNo, component: '', bp: '', comment: '' }
        this.projectOpenform.componentList.push(componentObj)
      }
      for (var k = 0; k < this.sites.length; k++) {
        if (this.sites[k].code === res.crProject.salesSite) {
          this.projectOpenform.salesSiteDescr = this.sites[k].description
        }
      }
      // const { data: res } = await this.$http.get('/customerBrand/allcustomerList')
      // this.customerList = res.rows
      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = res1.rows
      // this.bpListbak = this.bpList
      this.bpChange(res.crProject.bp)

      // const { data: res2 } = await this.$http.get('/customer/getDimensionList')
      // this.dimensionList = await res2.dimensionList
      this.brandChange(res.crProject.brand)

      // const { data: res3 } = await this.$http.get('/customer/getContactCrmList')
      // this.contactCRMList = await res3.contactCRMList
      // this.contactCRMListbak = this.contactCRMList
      this.contactChange(res.crProject.contact)

      this.pjChange(res.crProject.projectManager)

      // const { data: res4 } = await this.$http.get('/customer/getSalesRepList')
      // this.salesRepList = await res4.salesRepList
      this.salesRepChange(res.crProject.salesRep)

      // const { data: res5 } = await this.$http.get('/customer/getCategoryList')
      // this.categoryList = await res5.categoryList
      this.categoryChange(res.crProject.category)

      res.crProject.contact = var2.contact
      res.crProject.projectManager = var2.projectManager
      // console.log(66666)
      // console.log(this.crProjectList)
      // console.log(7777)
      // console.log(res.crProject)
    },
    async view (value, var2) {
      this.operation = 'view'
      this.projectOpenform.salesSiteDescr = ''
      this.projectOpenform.bpCompanyName = ''
      this.projectOpenform.brandDescr = ''
      this.projectOpenform.contactName = ''
      this.projectOpenform.pjName = ''
      this.projectOpenform.salesRepLastName = ''
      this.projectOpenform.categoryDescr = ''
      const { data: res } = await this.$http.get('/customer/getCRProject', { params: { value: value } })
      this.projectOpenform.crProject = res.crProject
      this.projectOpenform.stepList = res.stepList
      this.projectOpenform.associatedPrjList = res.associateProjectList
      this.projectOpenform.competitorList = res.competitorList
      this.projectOpenform.componentList = res.componentList
      this.picList = []
      this.docList = []
      if (res.fPicfileList !== null || res.fPicfileList.length !== 0) {
        for (var i = 0; i < res.fPicfileList.length; i++) {
          // console.log('fileName === ' + res.fPicfileList[i].fileName)
          this.picList.push({ name: res.fPicfileList[i].fileName, url: 'https://www.myirequest.com:8081/' + res.fPicfileList[i].fileName })
          // this.projectOpenform.picReference.push({ fileName: res.fPicfileList[i].fileName, type: res.fPicfileList[i].type })
        }
      }
      if (res.fDocfileList !== null || res.fDocfileList.length !== 0) {
        for (var j = 0; j < res.fDocfileList.length; j++) {
          this.docList.push({ name: res.fDocfileList[j].fileName, url: 'https://www.myirequest.com:8081/' + res.fDocfileList[j].fileName })
          // this.projectOpenform.docReference.push({ fileName: res.fDocfileList[j].fileName, type: res.fDocfileList[j].type })
        }
      }
      // this.siteChange(res.crProject.salesSite)
      // this.bpChange(res.crProject.bp)
      // this.brandChange(res.crProject.brand)
      // this.contactChange(res.crProject.contact)
      // this.salesRepChange(res.crProject.salesRep)
      // this.categoryChange(res.crProject.category)

      for (var k = 0; k < this.sites.length; k++) {
        if (this.sites[k].code === res.crProject.salesSite) {
          this.projectOpenform.salesSiteDescr = this.sites[k].description
        }
      }

      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = await res1.rows
      this.bpChange(res.crProject.bp)

      // const { data: res2 } = await this.$http.get('/customer/getDimensionList')
      // this.dimensionList = await res2.dimensionList
      this.brandChange(res.crProject.brand)

      /* const { data: res3 } = await this.$http.get('/customer/getContactCrmList')
      this.contactCRMList = await res3.contactCRMList */
      this.contactChange(res.crProject.contact)
      this.pjChange(res.crProject.projectManager)

      // const { data: res4 } = await this.$http.get('/customer/getSalesRepList')
      // this.salesRepList = await res4.salesRepList
      this.salesRepChange(res.crProject.salesRep)

      // const { data: res5 } = await this.$http.get('/customer/getCategoryList')
      // this.categoryList = await res5.categoryList
      this.categoryChange(res.crProject.category)

      res.crProject.contact = var2.contact
      res.crProject.projectManager = var2.projectManager

      this.operation = 'view'
      this.dialogFormVisible = true
    },
    async projectDialogSave (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('已提交表单')
          this.picList = []
          this.docList = []
          if (isNaN(this.projectOpenform.crProject.estimatedQty)) {
            this.$alert('Estimated QTY should be number', 'Alert', {
              dangerouslyUseHTMLString: true
            })
            return
          }

          if ((this.projectOpenform.crProject.sequenceNo.replace(/\s/g, '')) === '') {
            this.$alert('Please input the \'Sequence No\'.', 'Alert', {
              dangerouslyUseHTMLString: true
            })
            return
          }

          for (var i = 0; i < this.projectOpenform.stepList.length; i++) {
            if (this.projectOpenform.stepList[i].date === '' || this.projectOpenform.stepList[i].step === '') {
              this.projectOpenform.stepList.splice(i, 1)
            }
          }

          for (var j = 0; j < this.projectOpenform.associatedPrjList.length; j++) {
            if (this.projectOpenform.associatedPrjList[j].code === '') {
              this.projectOpenform.associatedPrjList.splice(j, 1)
            }
          }

          for (var k = 0; k < this.projectOpenform.competitorList.length; k++) {
            if (this.projectOpenform.competitorList[k].competitor === '') {
              this.projectOpenform.competitorList.splice(k, 1)
            }
          }

          for (var r = 0; r < this.projectOpenform.componentList.length; r++) {
            if (this.projectOpenform.componentList[r].component === '') {
              this.projectOpenform.componentList.splice(r, 1)
            }
          }

          this.$http.post('/customer/crProjectSave', { params: this.projectOpenform })

          this.dialogFormVisible = false
          this.$message.success('Update successfully!')

          this.getCRProjects()
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // const formData = new FormData()
      // this.fileList.forEach((_) => {
      //   formData.append('file', _.raw)
      // })
      // console.log('formData === ' + formData)
      // // const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      // await this.$http.get()
      // await this.$http.get(`//172.0.0.1:8081/customer/fileHandler?sequenceNo=${this.projectOpenform.crProject.sequenceNo}`,
      //   formData, { headers: { 'Content-Type': 'multipart/form-data' } }
      // // await this.$http.post(`//localhost:8081/fileHandler?sequenceNo=${this.projectOpenform.crProject.sequenceNo}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }
      // ).then((r) => {
      //   console.log(r)
      // }).catch((e) => {
      //   console.log(e)
      // console.log('fileList 222222 === ' + this.projectOpenform.reference)
      // })
    },
    checkSequenceNo (event) {
      // const { data: res } = await this.$http.get('/customer/getProjectId', { params: this.formInline })
      // if (res.result === '1') {
      //   this.$message({
      //     showClose: true,
      //     message: 'Sequence No already exists.',
      //     type: 'error'
      //   });
      // }

    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // exportToExcel () {
    //   /* 表示在当前页面打开新地址 */
    //   window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product, '_parent')
    // },
    async getCRProjects () {
      this.endofdevStart = ''
      this.endofdevEnd = ''

      if (this.formInline.endofdev) {
        if (this.formInline.endofdev.length) {
          this.endofdevStart = this.formInline.endofdev[0]
          this.endofdevEnd = this.formInline.endofdev[1]
          this.formInline.endofdev = [...this.formInline.endofdev].join(',')
        }
      }

      var brandsStr = ''
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/customer/crProjectList', { params: this.formInline })
      this.crProjectList = res.rows
      this.total = res.total
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      await this.$set(this.formInline, 'endofdev', [this.endofdevStart, this.endofdevEnd])
    },
    async getAssociateCRProjects () {
      const { data: res } = await this.$http.get('/customer/getAssociateCRProjectList')
      this.associatedPrjList = res.rows
    },
    async getSteps () {
      const { data: res } = await this.$http.get('/customer/stepList', { params: this.formInline })
      this.projectOpenform.stepList = res.rows
      this.maxStepId = res.maxStepId
    },
    addStepRow (value) {
      var obj, v
      for (var i = 0; i < this.projectOpenform.stepList.length; i++) {
        if (this.projectOpenform.stepList[i].date === '' || this.projectOpenform.stepList[i].step === '') {
          this.$alert('Date & Step field can not be empty', 'field checking', {
            confirmButtonText: 'Ok',
            callback: action => {
              this.$message({
                type: 'info',
                message: 'Date & Step field can not be empty'
              })
            }
          })
          return
        }
      }
      if (this.operation === 'add') {
        v = this.projectOpenform.stepList.length
        obj = { id: v, crProjectId: '', date: '', step: '', description: '', phaseEnd: false, reason: '' }
        this.projectOpenform.stepList.push(obj)
      } else {
        v = ++this.maxStepId
        obj = { id: v, crProjectId: '', date: '', step: '', description: '', phaseEnd: false, reason: '' }
        this.projectOpenform.stepList.push(obj)
      }
    },
    addAssoicatePrjRow (value) {
      for (var i = 0; i < this.projectOpenform.associatedPrjList.length; i++) {
        if (this.projectOpenform.associatedPrjList[i].code === '') {
          this.$alert('Code field can not be empty', 'field checking', {
            confirmButtonText: 'Ok',
            callback: action => {
              this.$message({
                type: 'info',
                message: 'Code field can not be empty'
              })
            }
          })
          return
        }
      }
      var obj, v
      if (this.operation === 'add') {
        v = this.projectOpenform.associatedPrjList.length
        obj = { id: v, crProjectId: '', code: '', description: '' }
        this.projectOpenform.associatedPrjList.push(obj)
      } else {
        v = ++this.maxAssociatePrjId
        obj = { id: v, crProjectId: '', code: '', description: '' }
        this.projectOpenform.associatedPrjList.push(obj)
      }
    },
    addCompetitorRow (value) {
      for (var i = 0; i < this.projectOpenform.competitorList.length; i++) {
        if (this.projectOpenform.competitorList[i].competitor === '' || this.projectOpenform.competitorList[i].competitorAmt === '' ||
          this.projectOpenform.competitorList[i].strength === '' || this.projectOpenform.competitorList[i].weakness === '') {
          this.$alert('Competitor & Competitor Amount & Strengths & Weaknesses field can not be empty', 'field checking', {
            confirmButtonText: 'Ok',
            callback: action => {
              this.$message({
                type: 'info',
                message: 'Competitor & Competitor11 Amount & Strengths & Weaknesses field can not be empty'
              })
            }
          })
          return
        }
      }
      var obj // , v
      if (this.operation === 'add') {
        // v = this.projectOpenform.competitorList.length
        obj = { id: 0, crProjectId: '', competitor: '', description: '', competitorAmt: '', strength: '', weakness: '' }
        this.projectOpenform.competitorList.push(obj)
      } else {
        // v = ++this.maxCompetitorId
        obj = { id: 0, crProjectId: '', competitor: '', description: '', competitorAmt: '', strength: '', weakness: '' }
        this.projectOpenform.competitorList.push(obj)
      }
    },
    addComponentRow (value) {
      for (var i = 0; i < this.projectOpenform.componentList.length; i++) {
        if (this.projectOpenform.componentList[i].component === '' || this.projectOpenform.componentList[i].bp === '') {
          this.$alert('Component & Business Partner field can not be empty', 'field checking', {
            confirmButtonText: 'Ok',
            callback: action => {
              this.$message({
                type: 'info',
                message: 'Component & Business Partner field can not be empty'
              })
            }
          })
          return
        }
      }
      var obj // , v
      if (this.operation === 'add') {
        // v = this.projectOpenform.competitorList.length
        obj = { id: 0, crProjectId: '', component: '', bp: '', comment: '' }
        this.projectOpenform.componentList.push(obj)
      } else {
        // v = ++this.maxCompetitorId
        obj = { id: 0, crProjectId: '', component: '', bp: '', comment: '' }
        this.projectOpenform.componentList.push(obj)
      }
    },
    delStepRow (value) {
      if (this.projectOpenform.stepList.length === 1) {
        this.projectOpenform.stepList.splice(0, 1)
        var obj = { id: 0, crProjectId: '', date: '', step: '', description: '', phaseEnd: false, reason: '' }
        this.projectOpenform.stepList.push(obj)
        return
      }
      for (var i = 0; i < this.projectOpenform.stepList.length; i++) {
        if (value === this.projectOpenform.stepList[i].id) {
          this.projectOpenform.stepList.splice(i, 1)
        }
      }
    },
    delAssociationPrjRow (value) {
      if (this.projectOpenform.associatedPrjList.length === 1) {
        this.projectOpenform.associatedPrjList.splice(0, 1)
        var obj = { id: 0, crProjectId: '', code: '', description: '' }
        this.projectOpenform.associatedPrjList.push(obj)
        return
      }
      for (var i = 0; i < this.projectOpenform.associatedPrjList.length; i++) {
        if (value === this.projectOpenform.associatedPrjList[i].id) {
          this.projectOpenform.associatedPrjList.splice(i, 1)
        }
      }
    },
    delCompetitorRow (value) {
      if (this.projectOpenform.competitorList.length === 1) {
        this.projectOpenform.competitorList.splice(0, 1)
        var obj = { id: 0, crProjectId: '', competitor: '', description: '', competitorAmt: '', strength: '', weakness: '' }
        this.projectOpenform.competitorList.push(obj)
        return
      }
      for (var i = 0; i < this.projectOpenform.competitorList.length; i++) {
        if (value === this.projectOpenform.competitorList[i].id) {
          this.projectOpenform.competitorList.splice(i, 1)
        }
      }
    },
    delComponentRow (value) {
      if (this.projectOpenform.componentList.length === 1) {
        this.projectOpenform.componentList.splice(0, 1)
        var obj = { id: 0, crProjectId: '', component: '', bp: '' }
        this.projectOpenform.componentList.push(obj)
        return
      }
      for (var i = 0; i < this.projectOpenform.componentList.length; i++) {
        if (value === this.projectOpenform.componentList[i].id) {
          this.projectOpenform.componentList.splice(i, 1)
        }
      }
    },
    async del (value) {
      const { data: res } = await this.$http.get('/customer/checkTaskExisted', { params: { value: value } })
      var exists = res.existed
      if (exists === 1) {
        this.$alert('Please delete the related Tasks first!', 'Warning', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        })
        return
      }

      const that = this
      this.$confirm('This will permanently delete the Project. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/customer/deleteCRProject', { params: { value: value } })
        .then(res => {
          that.getCRProjects()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    exportToExcel () {
      var etdStart = ''
      var etdEnd = ''
      if (this.formInline.endofdev && this.formInline.endofdev.length) {
        etdStart = this.formInline.endofdev[0]
        etdEnd = this.formInline.endofdev[1]
        this.formInline.endofdev = [...this.formInline.endofdev].join(',')
      }
      /* 表示在当前页面打开新地址https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/customer/exportCRProject?token=' +
        encodeURIComponent(this.formInline.token) +
        '&endofdev=' + this.formInline.endofdev + '&salesRep=' + this.formInline.salesRep +
        '&brands=' + this.formInline.brands +
        '&sequenceNo=' + this.formInline.sequenceNo +
        '&description=' + this.formInline.description +
        '&oppclo=' + this.formInline.oppclo +
        '&projectLeader=' + this.formInline.projectLeader, '_parent')
      this.$set(this.formInline, 'endofdev', [etdStart, etdEnd])
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc111===' + daterc)
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getCRProjects()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getCRProjects()
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
  .div-class {
    border:solid 1px #000;
  }
  .div-class2 {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-project-class {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-title-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    text-align: left;
    background-color: rgba(156, 156, 156);
  }
  .div-titlefin-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    margin-top:5px;
    background-color: rgba(156, 156, 156);
    text-align: left;
  }
  .dialogTitle{
    text-align: center;
  }

</style>
